module.exports = __webpack_public_path__ + "assets/img/9672f94b3c0ac1a7ddee2a59170af314.png";